import { useQuery } from "react-query";
import { API_URL_V1, get } from "../api";

export interface OrgMembership {
  organizationId: string;
  organizationName: string;
  role: string;
  status: string;
  creditLimit?: number | null;
  availableCredit?: number | null;
  usedCredit?: number | null;
}

function useUserOrgMemberships() {
  const { data, isLoading, isError } = useQuery<{ memberships: OrgMembership[] }>(
    ["user-org-memberships"],
    async () => {
      const token = localStorage.getItem("token");
      const res = await get(API_URL_V1 + "/user/org-memberships", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return (res as any).data ?? { memberships: [] };
    },
    { staleTime: 5 * 60 * 1000, retry: false }
  );

  const memberships: OrgMembership[] = data?.memberships ?? [];
  const primaryOrg = memberships[0] ?? null;
  const isOrgAdmin = memberships.some((m) => m.role?.toUpperCase() === "ADMIN");

  return { memberships, primaryOrg, isOrgAdmin, isLoading, isError };
}

export default useUserOrgMemberships;
